<script setup>
    //http://dev.yauty.com/activate/4bf855a6-18ef-4bba-9150-b1f8ffe02370
    import ActivateAccountForm from '@/components/activateAccount/ActivateAccountForm.vue';
</script>

<template>
    <section class="activate__container">
        <ActivateAccountForm />
    </section>
</template>

<style lang="scss" scoped>
</style>